import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { CustomAttributesInteractions } from './types';

export function customAttributeInteractionsEvent({
  action,
  title,
}: {
  action: CustomAttributesInteractions;
  title: string;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.CUSTOM_ATTRIBUTE_INTERACTION,
  };

  pushToDataLayer({
    ...eventAttributes,
    title,
    action,
  });
}
